module.exports = __webpack_public_path__ + "img/terms-icons.ce1a49fb.png";